import { useLocalSearchParams } from 'expo-router'

import { PublicationRewardScreen } from '@/src/features/publication/ui/screens/PublicationRewardScreen'
import type { TSourceParam } from '@/src/general/constants/routes'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

const PublicationRewardRouterPage = () => {
  const searchParams = useLocalSearchParams<{ id: string } & TSourceParam>()
  const { id: stringId, source = TRACKING_SOURCE.UNDEFINED } = searchParams
  const id = stringId && parseInt(stringId, 10)

  if (!id) return null

  return <PublicationRewardScreen id={id} source={source} searchParams={searchParams} />
}

export default PublicationRewardRouterPage
